import React from "react";

const ResearchInterest = () => {
  return (
    <div className='content'>
      <ul>
        <li>Social Network Analysis</li>
        <li>Graph Theory</li>
        <li>Data Mining</li>
        <li>Software Architectures</li>
        <li>Energy Monitoring Systems</li>
        <li>Web-based Geographical Information Systems.</li>
      </ul>
    </div>
  );
};

export default ResearchInterest;
